import { useEffect, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';

export const SelectMultiple = ({
  onAdd,
  onDelete,
  label,
  options,
  initialValues,
  className = '',
}) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    setSelectedItems((prevOptions) => {
      if (prevOptions.includes(value)) {
        onDelete(value);
        return prevOptions.filter((option) => option !== value);
      } else {
        onAdd(value);
        return [...prevOptions, value];
      }
    });
  };

  useEffect(() => {
    if (initialValues) setSelectedItems(initialValues.map(String));
  }, []);

  return (
    <Dropdown autoClose="outside">
      <Dropdown.Toggle
        className={`${className}`}
        id="selected-countries-availability"
        variant="primary"
      >
        {label}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Form className="px-3">
          {options.map((option) => (
            <Form.Check
              key={option.value}
              type="checkbox"
              label={option.label}
              value={option.value}
              checked={selectedItems.includes(option.value.toString())}
              onChange={handleCheckboxChange}
            />
          ))}
        </Form>
      </Dropdown.Menu>
    </Dropdown>
  );
};
